<template>
    <div :class="modalClass" v-if="open">
        <div class="modal-wrapper">
            <div class="modal-header">
                <div v-if="hasHeaderSlot">
                    <slot name="header" />
                </div>
                <div v-else >
                    <div class="modal-title">{{ title }}</div>
                    <div class="close" @click="$emit('close')">
                        <img src="/assets/images/icon/icon-close-black.svg" alt="close" />
                    </div>
                </div>
            </div>
            <div class="modal-content">
                <slot />
            </div>
            <div v-if="hasFooterSlot" class="modal-footer">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>
<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';

export default Vue.extend({
    name: 'Modal',
    props: {
        title: {
            type: String,
            default: '',
        },
        open: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        open: {
            handler(val) {
                this.toggleOverflow(val);
            }
        }
    },
    mounted() {
        if (this.open) {
            this.toggleOverflow(true);
        }
    },
    beforeDestroy() {
        this.toggleOverflow(false);
    },
    methods: {
        toggleOverflow(val) {
            this.$nextTick(() => {
                const overflow = val ? 'hidden' : 'auto';
                document.body.style.overflow = overflow;
            });
        }
    },
    computed: {
        modalClass() {
            return {
                'modal': true,
                'fade': this.open,
                'show': this.open,
            };
        },
        hasHeaderSlot() {
            return !!this.$slots.header;
        },

        hasFooterSlot() {
            return !!this.$slots.footer;
        },
    },
});
</script>
